export class ConveyanceSegmentConfigResponse {
  ConveyanceSegmentConfigID: number;
  ConveyanceSegmentID: number;
  ConfigName: string;
  ConfigValue: string;
}
